import Sentry from '@/services/sentry'
import PricingApi from '@/api/pricing'

const GET_OFFER_START = 'GET_OFFER_START'
const GET_OFFER_SUCCEEDED = 'GET_OFFER_SUCCEEDED'
const GET_OFFER_FAILED = 'GET_OFFER_FAILED'

const _state = {
  isGettingOffer: false,
  getOfferError: null,
  promotion: null,
}

const getters = {
  promotion(state) {
    return state.promotion
  },
  getOfferError(state) {
    return state.getOfferError
  },
  isGettingOffer(state) {
    return state.isGettingOffer
  },
}

const actions = {
  getOfferOnCancellation: async ({ commit }) => {
    commit(GET_OFFER_START)
    try {
      const response = await PricingApi.getOfferOnCancellation()
      commit(GET_OFFER_SUCCEEDED, response)
      return response
    } catch (error) {
      commit(GET_OFFER_FAILED, error)
      Sentry.captureException(error)
      throw error
    }
  },
}

const mutations = {
  [GET_OFFER_START](state) {
    state.isGettingOffer = true
  },
  [GET_OFFER_SUCCEEDED](state, offer) {
    state.isGettingOffer = false
    state.promotion = offer
    state.getOfferError = null
  },
  [GET_OFFER_FAILED](state, error) {
    state.isGettingOffer = false
    state.getOfferError = error
  },

}

export default {
  namespaced: true,
  state: _state,
  getters,
  actions,
  mutations,
}
